export class GetSharedData {
     public static readonly type = '[SharedData] Get shared data';
}
